import { RemoteBonusProducts } from '../../../data/usecases/bonus-products/bonus-products'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeRemoteBonusProductsCreate = ():any => new RemoteBonusProducts('/produtobonificacao/produtos', makeAxiosHttpClient())

export const makeRemoteBonusProducts = ():any => new RemoteBonusProducts('/produtobonificacao', makeAxiosHttpClient())

export const makeRemoteDeleteBonusProducts = (id:number):any => new RemoteBonusProducts(`/produtobonificacao/${id}`, makeAxiosHttpClient())
